export default "__VITE_ASSET__Cu6nXU2b__"